import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory, History } from 'history';

import { App } from './components/app/App';

import './index.scss';

window.renderPayment = (containerId: string, history: History) => {
  const elem = document.getElementById(containerId);

  if (elem) {
    ReactDOM.render(<App history={history} />, elem);
  }
};

window.unmountPayment = (containerId: string) => {
  const elem = document.getElementById(containerId);

  if (elem) {
    ReactDOM.unmountComponentAtNode(elem);
  }
};

if (!window.isRenderedByContainer) {
  import('./bootstrap').then(() => {
    const defaultHistory = createBrowserHistory({
      basename: process.env.PUBLIC_URL
    });

    window.renderPayment('root', defaultHistory);
  });
}
